
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/events.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-basic-events-demo-event-custom-click"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/basic/events.en.md?type=demo')
};